<template>
    <div class='select-container'>
        <div class='box' >
            <div id='option' @click="selectClick()">
                <div id="content" >
                    全部
                </div>
                <div  id='selectImg' >
                    <img class='arrow' id='img' :src='downArrow'/>
                </div>
            </div>
            <div id="selectItem"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: "SelectOption",
    props: {
    },
    data() {
        return {
            flag: false,
            downArrow: 'https://p4-ky.wsukwai.com/udata/pkg/kmovie/img/down_arrow.png',
            upArrow: 'https://p4-ky.wsukwai.com/udata/pkg/kmovie/img/up_arrow.png'
        }
    },
    created(){
        
    },
    methods: {
        selectClick(){
            const data = [
                { name: '全部', value: '' },
                { name: '近7天', value: '' },
                { name: '近30天', value: '' },
            ];
            const content = document.getElementById('content');
            const selectItem = document.getElementById('selectItem');
            const imgData = document.getElementById('img');
            if(!this.flag){
                const ul = document.createElement('ul');
                selectItem.appendChild(ul);
                for (let i = 0; i < data.length; i++) {
                    const li = document.createElement('li');
                    li.setAttribute('data-value', data[i].value);
                    li.innerText = data[i].name;
                    ul.appendChild(li);
                }
            }
            const lis = selectItem.getElementsByTagName('li');
            for (let i = 0; i < lis.length; i++) {
                if(lis[i].innerText === content.innerText){
                    lis[i].style.color = '#409eff'
                }else{
                    lis[i].style.color = '#141414'
                }
            }
            if (selectItem.style.display == 'none' || selectItem.style.display == '') {
                selectItem.style.display = 'block';
                imgData.setAttribute("src", 'https://p4-ky.wsukwai.com/udata/pkg/kmovie/img/up_arrow.png')
            } else {
                selectItem.style.display = 'none';
                imgData.setAttribute("src", 'https://p4-ky.wsukwai.com/udata/pkg/kmovie/img/down_arrow.png')
            }
            this.flag = true;
            for (let i = 0; i < lis.length; i++) {
                lis[i].onclick = function() {
                    imgData.setAttribute("src", 'https://p4-ky.wsukwai.com/udata/pkg/kmovie/img/down_arrow.png')
                    content.innerHTML = lis[i].innerHTML
                    selectItem.style.display = 'none';
                };
            }
        }
    },
};
</script>

<style lang="less">
*{
    margin: 0;
    padding: 0;
}
.select-container{
    display: flex;
    justify-content: flex-end;
    padding: 0.2rem 0.2rem 0 0;
    background: white !important;
    z-index: 999;
}
.box{
    display: flex;
    flex-direction: column;
    position: relative;
}
#option{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.01rem 0.1rem;
    width: 1.4rem;
    height: 0.5rem;
    border: 0.02rem solid #666;
    border-radius: 0.12rem;
    margin-bottom: 0.4rem;
}
#content {
    width: 1.6rem;
    height: 0.44rem;
    border-radius: 0.04rem;
    display: flex;
    align-items: center;
    font-size: 0.22rem;
    color: rgb(51, 51, 51);
    z-index: 999;
}
#selectImg {
    display: flex;
    align-items: center;
}
#selectItem {
    display: none;
    position: absolute;
    display: flex;
    justify-content: center;
    top: 0.6rem;
    width: 1.45rem;
    padding: 0.01rem 0.1rem;
    z-index: 999999;
    line-height: 0.5rem;
    font-size: 0.22rem;
    background: white !important;
}
ul {
    list-style: none;
    width: 1.6rem;
}
ul .li {
    list-style: none;
    margin: 0;
    padding: 0;
    width: 1.6rem;
    height: 0.4rem;
    font-size: 0.22rem;
}
.arrow {
    width: 0.3rem;
}
</style>
